var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.668 640h-.055c-20.027-.016-38.86-7.828-53.015-22.008L22.207 418.316c-29.164-29.218-29.164-76.761 0-105.976L290.988 43.043C318.688 15.289 355.543 0 394.762 0h170.527c41.352 0 75 33.64 75 75v170.004c0 39.191-15.273 76.031-43 103.726L327.672 618.066C313.508 632.211 294.684 640 274.668 640zM394.762 50c-25.844 0-50.13 10.074-68.383 28.363L57.594 347.66c-9.723 9.742-9.723 25.586 0 35.328l199.39 199.676c4.715 4.723 10.989 7.332 17.668 7.336h.02a24.842 24.842 0 0 0 17.664-7.309L561.953 313.36c18.274-18.25 28.336-42.53 28.336-68.355V75c0-13.785-11.215-25-25-25zm64.273 203.75c-41.355 0-75-33.64-75-75s33.645-75 75-75c41.356 0 75 33.64 75 75s-33.644 75-75 75zm0-100c-13.785 0-25 11.215-25 25s11.215 25 25 25c13.79 0 25-11.215 25-25s-11.21-25-25-25zm0 0",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.c79c6dbf25c19e72ed5fc2e149df1088.svg";
export { ForwardRef as ReactComponent };